import React from 'react';
import styles from './styles.module.scss';

const NotFoundPage = () => {
  return (
    <div className={styles.mainPage}>
      <div className={styles.imgWrapper}>
        <img src="/assets/images/404.png" alt="not-found" />
      </div>
    </div>
  );
};

export default NotFoundPage;
